import autoSign from "./autoSign.ts";
import decreaseDemands from "./decreaseDemands.ts";
import ensureEnoughPlayers from "./ensureEnoughPlayers.ts";
import getBest from "./getBest.ts";
import normalizeContractDemands from "./normalizeContractDemands.ts";
import play from "./play.ts";

export default {
	autoSign,
	decreaseDemands,
	ensureEnoughPlayers,
	getBest,
	normalizeContractDemands,
	play,
};
